import { Publisher } from '../../state/types';
import { createFindRecordById, createFindRecordByIdThrows } from '../findRecordById';

export const findById = createFindRecordById<Publisher>('publishers');

export const findByIdThrows = createFindRecordByIdThrows<Publisher>('publishers');
